// Issue #696: small chip rendered next to the existing "Cal" chip on file
// cards. Shows "No Cal" with a tooltip listing missing master types and the
// specific configuration needed, when a light frame can't be calibrated.

import React from 'react';
import { Chip, Tooltip, Box } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { missingCalibrationReason } from '../../utils/missingCalibrationReason';

/**
 * @param {{ file: object, size?: 'small'|'medium' }} props
 *   `file` is a userfile shape with `calibratable` + `calibratability` set by
 *   the userFilesRoutes (see /user-files/observation/:id and /user-files).
 *   Renders nothing when calibratable=true or calibratability is unknown.
 */
const MissingCalibrationChip = ({ file, size = 'small' }) => {
    const chip = missingCalibrationReason(file);
    if (!chip) return null;

    const tooltipContent = (
        <Box sx={{ whiteSpace: 'pre-line' }}>
            {chip.tooltipLines.join('\n')}
        </Box>
    );

    return (
        <Tooltip title={tooltipContent} placement="top">
            <Chip
                label={chip.label}
                size={size}
                color={chip.color}
                icon={<WarningIcon />}
                variant="outlined"
            />
        </Tooltip>
    );
};

export default MissingCalibrationChip;
